<template>
  <div style="width: 100%; margin-left: 1rem; margin-right: 1rem">
    <a-tabs :default-active-key="defaultTabActive">
      <a-tab-pane :key="1" :tab="$t('store.allProduct')" />
      <!-- <a-tab-pane :key="2" tab="Best Seller Product" />
      <a-tab-pane :key="3" tab="Discounted Product" /> -->
      <div slot="tabBarExtraContent">
        <a-checkbox @change="onCheckAllChange" :indeterminate="indeterminate" :checked="checkedAll">
          {{ $t('store.selectAll') }}
        </a-checkbox>
        <a-button :disabled="disableButtonBulkAdd" @click="() => addToStore()">
          {{ $t('store.addToStore') }}
        </a-button>
      </div>
    </a-tabs>
    <a-row>
      <a-col :xs="24" :md="24" :lg="9" class="order-2 mt-3">
        <a-input-search
          :placeholder="$t('store.searchProduct')"
          @change="onQueryChanged"
        />
      </a-col>
    </a-row>
    <a-row class="mt-3" type="flex" justify="space-between">
      <a-col :xs="24" :md="12" :lg="6">
        <a-form :form="filterForm">
          <a-form-item
            label="Sort By"
          >
            <a-select
              v-decorator="[
                'filter'
              ]"
              style="width: 100%"
              placeholder="Sort By"
              @change="handleFilterChange"
            >
              <a-select-option v-for="(item, index) in filter" :key="index" :value="item.value">
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-form>
      </a-col>
      <a-col :xs="24" :md="12" :lg="6">
        <a-form :form="filterForm">
          <a-form-item
            label="Filter"
          >
            <a-select
              v-decorator="[
                'filterByStore'
              ]"
              style="width: 100%"
              placeholder="Filter By"
              @change="handleFilterStore"
            >
              <a-select-option value="0">
                {{ $t('store.allProduct') }}
              </a-select-option>
              <a-select-option value="1">
                {{ $t('store.productOutStore') }}
              </a-select-option>
              <a-select-option value="2">
                {{ $t('store.productInStore') }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-form>
      </a-col>
      <a-col :xs="24" :md="12" :lg="6">
        <a-form :form="sortForm">
          <a-form-item
            label="Order By"
          >
            <a-select
              v-decorator="[
                'sort'
              ]"
              style="width: 100%"
              placeholder="Order By"
              @change="handleSortChange"
            >
              <a-select-option v-for="(item, index) in sort" :key="index" :value="item.value">
                <a-icon slot="suffixIcon" :type="item.icon" />
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-form>
      </a-col>
    </a-row>
    <a-tabs />
    <div v-if="!products.length && !loading" class="d-flex justify-content-center">
      <div class="text-bold" style="font-size: 30px">
        <strong> {{ $t('store.productNotFound') }} </strong>
      </div>
    </div>
    <div class="row row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5 gutter-xs-1 gutter-md-2 gutter-lg-3 mx-n2">
      <div class="col px-2" v-for="(product, index) in products" :key="index">
        <ItemGrid
          :product="product"
          :index="index"
          :checkedAll="checkedAll"
          :dataChecked="dataChecked"
          @addData="addData"
          @deleteData="deleteData"
          @addToStore="addToStore"
          @removeFromStrore="removeFromStrore"
          :loading="loading"
        />
      </div>
    </div>
    <div class="py-5 d-flex justify-content-center align-items-center" v-if="totalProducts !== products.length">
      <a-button
        @click.prevent="loadMore"
        :loading="loading"
        size="large"
      >
        {{ $t('store.loadMore') }}
      </a-button>
    </div>
  </div>
</template>

<script>
import ItemGrid from '@/components/Product/ItemGrid'
import { mapState } from 'vuex'

const filter = [
  {
    label: 'New Product',
    value: 'newproduct',
  },
  {
    label: 'Featured Product',
    value: 'featured',
  },
  {
    label: 'Special Product',
    value: 'special',
  },
  {
    label: 'Best Seller Product',
    value: 'bestseller',
  },
  {
    label: 'Product Name',
    value: 'product_name',
  },
  {
    label: 'Commission',
    value: 'commission',
  },
  {
    label: 'Discount',
    value: 'discount',
  },
  {
    label: 'Price',
    value: 'price',
  },
  {
    label: 'Stock',
    value: 'stock',
  },
  {
    label: 'Sold Item',
    value: 'sold',
  },
]
const sort = [
  {
    label: 'ASC',
    value: 'asc',
    icon: 'caret-up',
  },
  {
    label: 'DESC',
    value: 'desc',
    icon: 'caret-down',
  },
]
export default {
  components: {
    ItemGrid,
  },
  data: function () {
    return {
      defaultTabActive: 1,
      checkedAll: false,
      dataChecked: [],
      indeterminate: false,
      page: 1,
      limit: 35,
      timeout: 0,
      filter,
      filterForm: this.$form.createForm(this),
      filterBy: null,
      sort,
      sortForm: this.$form.createForm(this),
      sortBy: null,
      disableButtonBulkAdd: true,
      instore: null,
      querySearch: null,
    }
  },
  computed: {
    ...mapState('product', {
      loading: state => state.loading,
      products: state => state.products,
      totalProductOutStore: state => state.totalProductOutStore,
      totalProducts: state => state.totalProducts,
    }),
  },
  methods: {
    onCheckAllChange (e) {
      this.checkedAll = e.target.checked
      if (e.target.checked) {
        this.indeterminate = false
        this.dataChecked = []
        this.disableButtonBulkAdd = false
        this.products.map((item, index) => item.in_store === 0 && this.dataChecked.push(item.product_id))
      } else {
        this.disableButtonBulkAdd = true
        this.dataChecked = []
      }
    },
    addData (param) {
      this.dataChecked.push(param)
      if (this.totalProductOutStore === this.dataChecked.length) {
        this.indeterminate = false
        this.checkedAll = true
        this.disableButtonBulkAdd = false
      } else if (!!this.dataChecked.length && this.dataChecked.length < this.totalProductOutStore) {
        this.checkedAll = false
        this.indeterminate = true
        this.disableButtonBulkAdd = false
      }
      // console.log(param)
    },
    deleteData (param) {
      this.dataChecked = this.dataChecked.filter(item => item !== param)
      if (this.totalProductOutStore === this.dataChecked.length) {
        this.indeterminate = false
        this.checkedAll = true
        this.disableButtonBulkAdd = false
      } else if (!!this.dataChecked.length && this.dataChecked.length < this.totalProductOutStore) {
        this.checkedAll = false
        this.indeterminate = true
        this.disableButtonBulkAdd = false
      } else if (!this.dataChecked.length) {
        this.checkedAll = false
        this.indeterminate = false
        this.disableButtonBulkAdd = true
      }
    },
    loadMore () {
      this.page += 1
      this.$store.dispatch('product/GETPRODUCTLIST', {
        page: this.page,
        limit: this.limit,
        sort: this.filterBy ? this.filterBy : null,
        order: this.sortBy ? this.sortBy : null,
        instore: this.instore ? this.instore : null,
        q: this.querySearch ? this.querySearch : null,
      })
    },
    onQueryChanged (e) {
      const value = e.target.value
      this.querySearch = e.target.value
      if (this.timeout) clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        // this.filterForm.resetFields('filter')
        // this.sortForm.resetFields('sort')
        this.filterForm.resetFields()
        this.sortForm.resetFields()
        this.instore = null
        this.filterBy = null
        this.sortBy = null
        this.$store.dispatch('product/GETPRODUCTLIST', { q: value })
      }, 1000)
    },
    addToStore (value) {
      if (value) {
        this.dataChecked = []
        this.dataChecked.push(value)
      }
      this.$store.dispatch('product/ADDPRODUCTTOSTORE', this.dataChecked)
        .then(_ => {
          return this.$store.dispatch('product/GETPRODUCTLIST', {
            page: 1,
            limit: this.limit * this.page,
            sort: this.filterBy ? this.filterBy : null,
            order: this.sortBy ? this.sortBy : null,
            instore: this.instore ? this.instore : null,
            q: this.querySearch ? this.querySearch : null,
          })
        })
        .then(_ => {
          this.dataChecked = []
          this.checkedAll = false
          this.indeterminate = false
          this.disableButtonBulkAdd = true
          this.$notification.success({
            message: this.$t('store.successAddProduct'),
          })
        })
        .catch(err => {
          this.$notification.error({
            message: this.$t('store.failedAddProduct'),
            description: err.response?.data?.message || err.message,
          })
        })
    },
    removeFromStrore (value) {
      if (value) {
        this.dataChecked = []
        this.dataChecked.push(value)
      }
      this.$store.dispatch('product/DELETEFROMSTORE', this.dataChecked)
        .then(_ => {
          return this.$store.dispatch('product/GETPRODUCTLIST', {
            page: 1,
            limit: this.limit * this.page,
            sort: this.filterBy ? this.filterBy : null,
            order: this.sortBy ? this.sortBy : null,
            instore: this.instore ? this.instore : null,
            q: this.querySearch ? this.querySearch : null,
          })
        })
        .then(_ => {
          this.$notification.success({
            message: this.$t('store.successRemoveProduct'),
          })
        })
        .catch(err => {
          this.$notification.error({
            message: this.$t('store.failedRemoveProduct'),
            description: err.response?.data?.message || err.message,
          })
        })
    },
    handleFilterChange (value) {
      this.filterBy = value
      this.page = 1
      this.$store.dispatch('product/GETPRODUCTLIST', {
        page: this.page,
        limit: this.limit,
        sort: this.filterBy,
        order: this.sortBy ? this.sortBy : null,
        instore: this.instore ? this.instore : null,
        q: this.querySearch ? this.querySearch : null,
      })
    },
    handleSortChange (value) {
      this.sortBy = value
      this.page = 1
      this.$store.dispatch('product/GETPRODUCTLIST', {
        page: this.page,
        limit: this.limit,
        sort: this.filterBy ? this.filterBy : null,
        order: value,
        instore: this.instore ? this.instore : null,
        q: this.querySearch ? this.querySearch : null,
      })
    },
    handleFilterStore (value) {
      this.instore = value
      this.page = 1
      this.$store.dispatch('product/GETPRODUCTLIST', {
        page: this.page,
        limit: this.limit,
        sort: this.filterBy,
        order: this.sortBy,
        instore: value,
        q: this.querySearch ? this.querySearch : null,
      })
    },
  },
  created () {
    this.$store.dispatch('product/GETPRODUCTLIST', { page: this.page, limit: this.limit })
  },
}
</script>
